import React from "react";
import getIcon from "../../utils/getIcon";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
const TasksOverviewChart = ({ overviewInfo = [], permission }) => {
  const safeRender = (val) =>

    val === null || val === undefined || typeof val === "object" ? "-" : val;

  if (permission?.pf_view !== 1) {
    return null;
  }

  const mergedInfo = overviewInfo.reduce(
    (acc, item) => ({ ...acc, ...item }),
    {}
  );
  const moduleId = overviewInfo[0]?.moduleId;

  return (
    <>
      <div className="col-lg-3 task-overview-card">
        <div className="card mb-4 stretch stretch-full">
          <Link to={`/master/branch-list?id=${overviewInfo[0]?.moduleId}`}>
            <div className="card-header-1 d-flex align-items-center justify-content-between">
              <div className="d-flex gap-3 align-items-center">
                <div className="avatar-text">
                  <i className="fs-16">{getIcon("feather-star")}</i>
                </div>
                <div>
                  <div className="fw-semibold text-dark fs-16">
                    Total Branches
                  </div>
                </div>
              </div>
              <div className="fs-4 fw-bold text-dark">
                {safeRender(mergedInfo?.TotalBranches)}
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className="col-lg-3 task-overview-card">
        <div className="card mb-4 stretch stretch-full">
          <Link to={`/employee/employee-list?id=${overviewInfo[1]?.moduleId}`}>
            <div className="card-header-1 d-flex align-items-center justify-content-between">
              <div className="d-flex gap-3 align-items-center">
                <div className="avatar-text">
                  <i className="fs-16">{getIcon("feather-file-text")}</i>
                </div>
                <div>
                  <div className="fw-semibold text-dark fs-16">
                    Total Employees
                  </div>
                </div>
              </div>
              <div className="fs-4 fw-bold text-dark">
                {safeRender(mergedInfo?.TotalEmployees)}
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className="col-lg-3 task-overview-card">
        <div className="card mb-4 stretch stretch-full">
          <Link to={`/task/task-list?id=${overviewInfo[2]?.moduleId}`}>
            <div className="card-header-1 d-flex align-items-center justify-content-between">
              <div className="d-flex gap-3 align-items-center">
                <div className="avatar-text">
                  <i className="fs-16">{getIcon("feather-airplay")}</i>
                </div>
                <div>
                  <div className="fw-semibold text-dark fs-16">
                    Total Pending Task
                  </div>
                </div>
              </div>
              <div className="fs-4 fw-bold text-dark">
                {safeRender(mergedInfo?.TotalPendingTask)}
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className="col-lg-3 task-overview-card">
        <div className="card mb-4 stretch stretch-full">
          <div className="card-header-1 d-flex align-items-center justify-content-between">
            <div className="d-flex gap-3 align-items-center">
              <div className="avatar-text">
                <i className="fs-16">{getIcon("feather-bell")}</i>
              </div>
              <div>
                <div className="fw-semibold text-dark fs-16">
                  Total Upcoming Task
                </div>
              </div>
            </div>
            <div className="fs-4 fw-bold text-dark">
              {safeRender(mergedInfo?.upcoming_tasks)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TasksOverviewChart;
